export default __webpack_public_path__ + "static/logo-footer-84e6dd47c8e2daabc421732c87fb14be.svg";